import { Process } from "../Process";
import { ewent } from "../reactive";
import { Alt1Overlay } from "./overlay/Alt1Overlay";
import { LifetimeManager } from "../lifetime/LifetimeManager";
export class Alt1OverlayManager {
    constructor() {
        this.HEARTBEAT = 20000;
        this.heartbeat = ewent();
        this.page_lifetime_manager = new LifetimeManager();
        window.addEventListener("pagehide", () => {
            this.page_lifetime_manager.endLifetime();
        });
    }
    startTracking() {
        if (this.process)
            return;
        const self = this;
        this.process = new class extends Process.Interval {
            constructor() {
                super(self.HEARTBEAT); // Beat every 20 seconds
            }
            tick() {
                self.heartbeat.trigger(null);
            }
        };
        this.process.run();
    }
    onHeartbeat(f) {
        const handler = this.heartbeat.on(f);
        this.startTracking();
        return handler;
    }
    bindToPageLifetime(overlay) {
        this.page_lifetime_manager.bind(overlay);
    }
    create() {
        return new Alt1Overlay(undefined, this);
    }
}
